import { useState ,useEffect} from "react";
import { useDispatch ,useSelector} from "react-redux";
import reload from "../../assets/icons/reload.svg";
import CustomTabsV2 from "../universal/CustomTabsV2";
import CollapsibleRightPanel from "../universal/CollapsibleRightPanel";
import {AddChurchHooks}  from "../../screens/Program/hooks/Programhooks";
import {AllChurchHooks}  from "../../screens/Program/hooks/Programhooks";

import DropdownWithTags from "../universal/DropdownWithTags";
import LayoutDropdown from "../universal/LayoutDropdown";
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";
import edit from "../../assets/icons/edit.svg";
import close from "../../assets/icons/close.svg";
import ReactModal from "react-modal";
import { ImCross } from "react-icons/im";
import LanguageDrawer from "../universal/LanguageDrawer";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { FaInfoCircle } from "react-icons/fa";
import UploadControlsV2 from "../TWG/UploadControlsV2";
import RelatedVideoInput from "../categories/RelatedVideoInput";
import VideoLibraryModal from "../TWG/VideoLibraryModal";
import GoogleMapInput from '../../components/MapInput/MapInput'
import GalleryPickerField from "../../components/ImageGallery/GalleryPickerField"
import GalleryVideoField from "../../components/videoGallery/GalleryPickerField"
import VideoPickerfield from "../../components/ChannelVideo/GalleryPickerField"
import MinistryVideoField from "../../components/MinistryVideo/GalleryPickerField"
import ReactQuill from "react-quill";
import { toast } from "react-toastify";
const AddVideosFields = ({ setLoading, data,rowData,onClose,church }) => {
  // const { options } = GetRelatedVideosHooks();
  const currentUrl = window.location.href;
  const churchGalleryId=church;
  const dispatch = useDispatch();

   const {
    activeTab,
    activeLanguageDetails,
    setActiveLanguageDetails,
    setActiveTab,
    handleInputChange,
    handleFileInputChange,
    handleSave,
    handleSaveCarecellCoverImage,
    readLanguageData,
    videoInputs,

    videoErrors,
    videoUrlsInputs,
    showVideoLibraryModal,
    setShowVideoLibraryModal,
    setVideoUrlsInputs,
    setDownloadUrlsInputs,
    setTumbNailUrlsInputs,
    tumbNailUrlsInputs,
    UdownloadrlsInputs,
    handleChange,
    handleCarecellChange,
    selectedOptions,
    setSelectedOptions,
    deleteRelatedVideo,
    setSelectedRelatedVideoIndex,
    handleDropdownChange,
    setLayoutValues,
    handleVideoLayoutChange,
    layoutValues,
    initialLayoutValues,
    setLayoutInfo,
    layoutInfo,
    handleDateChange,
    handleAddLayoutToArray,
    layoutArray,
    setAddedLayout,
    addedLayout,
    handleVideoDateChange,
    options,
    handleDeleteLayoutFromArray,
    setIsLayoutEdit,
    isLayoutEdit,
    setEditLayoutIndex,
    setEditTargetLayout,
    editTargetLayout,
    handleLayoutUpdate,
    updateStateWithTranslation,
    handleCommonTumbNailInputChange,
    setCommonUrlsInputs,
    commonVideoUrlsInputs,
    previewUrlsInputs,
    setPreviewUrlsInputs,
    languagemeta,
    setLanguagemeta,
    setIsLanguageSave,
    handleSaveLanguage,
    handleLibraryVideoSelection,
    handleSendNotification,
    handleUpdateChurch,
    setcarecellInputs,
    setImageSet,
    setVideoInputs,
    thumbnailImage, setThumbnailImage,
    isLive,setIslive,
    isDefault,setIsDefault,
    setvideoset

  } = AddChurchHooks(setLoading, data);


  const [selectedLocation, setSelectedLocation] = useState({
    lat: "",
    lng: "",
    address: ""
  });
              const churches = useSelector((state) => state.churches.churches);

const handleGallerySelect = (imageSet) => {

    setImageSet(imageSet)
  setTumbNailUrlsInputs({
      webUploadUrl: imageSet?.target?.value?.web?.url || "",
      tabletUploadUrl: imageSet?.target?.value?.tablet?.url || "",
      mobileUploadUrl: imageSet?.target?.value?.mobile?.url || "",

    });


  };

      const [description, setDescription] = useState(videoInputs?.description || "");

      useEffect(() => {
        setDescription(videoInputs?.description || "");
      }, [videoInputs?.description]);
      const handleThumbSelect = (img) => {
                setThumbnailImage(img?.target?.value?.[0]?.id);
        setvideoset(img)
      };
      // const isQuillEmpty = (value) => {
      //   const div = document.createElement("div");
      //   div.innerHTML = value || "";
      //   return !div.textContent?.trim();
      // };
      // const validateProgramFields = () => {
      //   if (!church) {
      //     toast.error("Church is required");
      //     return false;
      //   }

      //   if (!videoInputs?.typeofProgram) {
      //     toast.error("Program Type is required");
      //     return false;
      //   }

      //   if (!videoInputs?.programName?.trim()) {
      //     toast.error("Program Name is required");
      //     return false;
      //   }

      //   if (
      //     !videoInputs?.description ||
      //     isQuillEmpty(videoInputs.description)
      //   ) {
      //     toast.error("Description is required");
      //     return false;
      //   }

      //   if (!videoInputs?.programDate) {
      //     toast.error("Program Date is required");
      //     return false;
      //   }

      //   if (!videoInputs?.programTime) {
      //     toast.error("Program Time is required");
      //     return false;
      //   }

      //   if (!videoInputs?.latitude || !videoInputs?.longitude) {
      //     toast.error("Please select a location on the map");
      //     return false;
      //   }

      //   if (!videoInputs?.address?.trim()) {
      //     toast.error("Address is required");
      //     return false;
      //   }

      //   if (!videoInputs?.placename?.trim()) {
      //     toast.error("Place Name is required");
      //     return false;
      //   }



      //   return true;
      // };
      const [apiProgram, setApiProgram] = useState(null);
      const { fetchAllChurches } = AllChurchHooks();

      useEffect(() => {
        if (!rowData?.programObjId || !church?._id) return;

        fetchAllChurches(
          1,
          100,
          {},
          (res) => {
            if (!res?.data?.length) return;

            // 🔥 programs already flattened
            const program = res.data.find(
              (p) => p.programObjId === rowData.programObjId
            );

            if (program) {
              setApiProgram(program);
            }
          },
          church._id
        );
      }, [rowData?.programObjId, church?._id]);
      useEffect(() => {
        if (!apiProgram) return;

        // 🔹 Language metas (important)
        if (apiProgram?.languagemetas) {
          setLanguagemeta(apiProgram.languagemetas);
        }

        setVideoInputs({
          _id: apiProgram.programObjId,
          churchId: apiProgram.churchId,
          typeofProgram: apiProgram.typeofProgram || "",
          programName: apiProgram.programName || "",
          description: apiProgram.description || "", // ✅ HTML preserved
          programDate: apiProgram.programDate || "",
          programTime: apiProgram.programTime || "",
          placename: apiProgram.placename || "",
          latitude: apiProgram.latitude || "",
          longitude: apiProgram.longitude || "",
          liveStreamUrl: apiProgram.liveStreamUrl || "",
          contactperson: apiProgram.contactperson || "",
          contactphone: apiProgram.contactphone || "",
          contactemail: apiProgram.contactemail || "",
          author: apiProgram.author || "",
          subscriptionUrl: apiProgram.subscriptionUrl || "",
          registerUrl: apiProgram.registerUrl || "",
        });

        // 🔥 ReactQuill source of truth
        setDescription(apiProgram.description || "");
      }, [apiProgram]);
      const cleanHtmlContent = (htmlContent) => {
        if (!htmlContent) return htmlContent;

        // Remove ALL color-related styles and formatting
        return htmlContent
          // Remove background-color styles
          .replace(/style="[^"]*background-color[^;"]*;?[^"]*"/gi, '')
          // Remove color styles
          .replace(/style="[^"]*color:[^;"]*;?[^"]*"/gi, '')
          // Remove any style attribute that contains color (more comprehensive)
          .replace(/style="[^"]*(color|background|background-color)[^"]*"/gi, '')
          // Remove any style attributes with single quotes
          .replace(/style='[^']*'/gi, '')
          // Remove empty style attributes
          .replace(/style=""/gi, '')
          // Remove any span tags that might have had styling (keeps span but removes all styles)
          .replace(/<span[^>]*>/gi, '<span>')
          // Remove any font tags that might bring color
          .replace(/<font[^>]*>/gi, '')
          .replace(/<\/font>/gi, '')
          // Also remove any color-related CSS classes
          .replace(/class="[^"]*color[^"]*"/gi, '');
      };
  return (
    <div className="flex flex-col md:flex-row h-full w-full flex-1 rounded-2xl overflow-hidden">
      <div className="flex h-full flex-1">
        <LanguageDrawer
          languageData={readLanguageData}
          activeTab={readLanguageData}
          setActiveTab={setActiveTab}
          setActiveLanguageDetails={setActiveLanguageDetails}
          languagemeta={languagemeta}
          setIsLanguageSave={setIsLanguageSave}
        />
        <div className="flex h-full flex-1">
          <div className="flex flex-col h-full w-full bg-greyishV2 bg-opacity-50 md:border-l md:border-r border-greyish border-opacity-30 overflow-auto">
            <div className="flex gap-4 items-center justify-between h-[64px] px-4 border-b border-[#28292a]">
              <p className="text-white font-semibold text-lg">
                {activeTab === "en"
                  ? "Add Program"
                  : `Translate Churche to ${activeLanguageDetails?.language_name}`}
              </p>
              <div className="flex items-center gap-5">
                {activeTab !== "en" && !data?._id && (
                  <p
                    className="flex items-center gap-1 text-greyish text-[11px] font-medium cursor-pointer whitespace-nowrap"
                    onClick={()=>updateStateWithTranslation(videoInputs)}
                  >
                    <img src={reload} alt="" /> Auto fill data with google translation
                  </p>
                )}
                {!data?._id && (
                  <button
                    className="text-yellowish bg-blackish font-medium text-[12px] whitespace-nowrap border border-yellowish rounded-xl py-2 px-6"
                    onClick={handleSendNotification}
                  >
                    Send Notification
                  </button>
                )}
                {activeTab === "en" ? (
                  <div className="w-full flex items-end justify-end gap-4">
                    {/* <button
                      className="text-yellowish bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
                      onClick={handleSave}
                    >
                      {rowData?._id ? "Update Church" : "Save Church"}
                    </button> */}
                    {
                      videoInputs?._id ?
                      <button
                      className="text-yellowish bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
                      // onClick={() => handleUpdateChurch(rowData)}
                      onClick={async () => {
                        try {
                          await handleUpdateChurch(church,videoInputs,rowData); // wait until API completes and toast appears
                          onClose();          // now close the modal
                        } catch (err) {
                                                    // optionally keep modal open or close anyway
                        }
                      }}
                    >Update Program</button>
                    :
                    <button
                    className="text-yellowish bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
                    onClick={async () => {
                      try {
                        await handleSave(church?._id, onClose);
                        onClose();
                      } catch (err) {
                                              }
                    }}


                  >Save Program</button>
                    }
                  </div>
                ) : !data?._id ? (
                  <div className="w-full flex items-end justify-end gap-4">
                    <button
                      className="text-yellowish bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
                      onClick={handleSaveLanguage}
                    >
                      Save Language
                    </button>
                  </div>
                ) : null}
              </div>
            </div>
            {/* TAB CONTENT  */}
            {activeTab !== "en" && data?._id ? (
              <div className="flex items-center justify-center text-white gap-1 py-28">
                Church translation in{" "}
                <span className="italic">{activeLanguageDetails?.language_name}</span> is available
                for saved churches
              </div>
            ) : (
                <div className="px-4 my-4 h-full">
                <div className="overflow-y-auto overflow-x-hidden px-2">
<div className="grid md:grid-cols-2 grid-cols-1 gap-x-4 gap-y-4 mx-1 w-full">

  {/* Church Dropdown */}
  <div className="md:col-span-2 col-span-1 relative">
  <label className="text-[12px] text-greyish font-medium leading-4 flex items-center gap-2">
    Church *
  </label>

  <input
    type="text"
    name="church_id"
    placeholder="Enter Church Name"
    className="bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10"
    value={church ? church.churchName : ""}

    readOnly
  />

  {/* {videoErrors?.church_id && (
    <p className="text-red-500 relative bottom-[-6px] text-[10px] left-2">
      Church selection is required
    </p>
  )} */}
</div>


  {/* Program Type */}
  <div className="md:col-span-2 col-span-1 relative">
  <label className="text-[12px] text-greyish font-medium leading-4">
    Program Type *
  </label>

  <div className="relative">
    <select
      name="typeofProgram"
      className="appearance-none bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10 pr-10 focus:outline-none focus:ring-0"
      value={videoInputs?.typeofProgram || ""}
      onChange={handleChange}
    >
      <option value="">Select Program Type</option>
      <option value="Churches">Event</option>
      <option value="Channels">Program</option>
    </select>

    {/* Custom dropdown arrow */}
    <div className="pointer-events-none absolute right-3 top-[50%] translate-y-[-50%] text-white">
      <svg
        className="w-4 h-4"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
      </svg>
    </div>
  </div>

  {/* {videoErrors?.typeofProgram && (
    <p className="text-red-500 relative bottom-[-6px] text-[10px] left-2">
      Program Type is required
    </p>
  )} */}
</div>


  {/* Program Name */}
  <div className="md:col-span-2 col-span-1">
    <label className="text-[12px] text-greyish font-medium leading-4">
      Program Name *
    </label>
    <input
      name="programName"
      placeholder="Enter Program Name"
      type="text"
      className="bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10"
      value={videoInputs?.programName || ""}
      onChange={handleChange}
    />
    {/* {videoErrors?.programName && (
      <p className="text-red-500 relative bottom-[-6px] text-[10px] left-2">
        Program Name is required
      </p>
    )} */}
  </div>

  {/* Description */}
 {/* Description */}
<div className="md:col-span-2 col-span-1">
  <label className="text-[12px] text-greyish font-medium leading-4">
    Description *
  </label>

  <div className="mt-2">
    <ReactQuill
      theme="snow"
      value={description} // controlled value
      onChange={(value) => {
        const cleanedValue = cleanHtmlContent(value); // Clean the HTML content
        setDescription(cleanedValue); // update local state
        handleChange({ target: { name: "description", value: cleanedValue } }); // propagate to parent
      }}
      placeholder="Enter Description"
      className="text-white text-[14px] font-medium rounded-md bg-blackish quill-custom"
    />
  </div>

  {/* {videoErrors?.description && (
    <p className="text-red-500 relative bottom-[-6px] text-[10px] left-2">
      Description is required
    </p>
  )} */}
</div>

  {/* Program Date & Program Time side by side */}
  <div className="w-full">
    <label className="text-[12px] text-greyish font-medium leading-4">
      Program Date *
    </label>
    <input
      type="date"
      name="programDate"
      className="bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10"
      value={videoInputs?.programDate || ""}
      onChange={handleChange}
    />
    {/* {videoErrors?.programDate && (
      <p className="text-red-500 relative bottom-[-6px] text-[10px] left-2">
        Program Date is required
      </p>
    )} */}
  </div>

  <div className="w-full relative">
  <label className="text-[12px] text-greyish font-medium leading-4">
    Program Time *
  </label>

  <div className="relative">
    <select
      name="programTime"
      className="appearance-none bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10 pr-10 focus:outline-none focus:ring-0"
      value={videoInputs?.programTime || ""}
      onChange={handleChange}
    >
      <option value="">Select Program Time</option>
      {(() => {
        const times = [];
        for (let hour = 0; hour < 24; hour++) {
          for (let minute = 0; minute < 60; minute += 15) {
            const period = hour >= 12 ? "PM" : "AM";
            const displayHour = hour % 12 || 12;
            const formattedMinute = minute.toString().padStart(2, "0");
            const timeString = `${displayHour}:${formattedMinute} ${period}`;
            const value = `${hour.toString().padStart(2, "0")}:${formattedMinute}`;
            times.push({ label: timeString, value: value });
          }
        }
        return times.map((time) => (
          <option key={time.value} value={time.value}>
            {time.label}
          </option>
        ));
      })()}
    </select>

    {/* Custom arrow */}
    <div className="pointer-events-none absolute right-3 top-[50%] translate-y-[-50%] text-white">
      <svg
        className="w-4 h-4"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M19 9l-7 7-7-7"
        />
      </svg>
    </div>
  </div>

  {/* {videoErrors?.programTime && (
    <p className="text-red-500 relative bottom-[-6px] text-[10px] left-2">
      Program Time is required
    </p>
  )} */}
</div>


  {/* Map for placename, latitude, longitude */}
 {/* Google Map Picker */}
<div className="md:col-span-2 col-span-1">
  <label className="text-[12px] text-greyish font-medium leading-4">
    Location on Map *
  </label>
  <GoogleMapInput
    defaultLocation={{
      lat: videoInputs?.latitude || 40.7128,
      lng: videoInputs?.longitude || -74.0060 ,
    }}
    onLocationChange={({ lat, lng, address }) => {
      setSelectedLocation({ lat, lng, address });
      handleChange({ target: { name: "address", value: address } });
      handleChange({ target: { name: "latitude", value: lat } });
      handleChange({ target: { name: "longitude", value: lng } });
    }}
  />
</div>

{/* Place Name */}
<div className="md:col-span-2 col-span-1">
  <label className="text-[12px] text-greyish font-medium leading-4">
    Address *
  </label>
  <input
    type="text"
    name="address"
    placeholder="Enter Address"
    className="bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10"
    value={ selectedLocation?.address || ""}
    onChange={handleChange}
  />
</div>
<div className="md:col-span-2 col-span-1">
  <label className="text-[12px] text-greyish font-medium leading-4">
    Place Name *
  </label>
  <input
    type="text"
    name="placename"
    placeholder="Selected place name"
    className="bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10"
    value={ videoInputs?.placename || ""}
    onChange={handleChange}
  />
</div>

{/* Latitude and Longitude side-by-side */}
<div className="md:col-span-1 col-span-1 hidden">
  <label className="text-[12px] text-greyish font-medium leading-4">
    Latitude *
  </label>
  <input
    type="text"
    name="latitude"
    placeholder="Latitude"
    className="bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10"
    value={selectedLocation.lat || videoInputs?.latitude}
    onChange={handleChange}
  />
</div>

<div className="md:col-span-1 col-span-1 hidden">
  <label className="text-[12px] text-greyish font-medium leading-4">
    Longitude *
  </label>
  <input
    type="text"
    name="longitude"
    placeholder="Longitude"
    className="bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10"
    value={selectedLocation.lng || videoInputs?.longitude}
    onChange={handleChange}
  />
</div>


  {/* LiveStream URL */}
  <div className="md:col-span-2 col-span-1">
    <label className="text-[12px] text-greyish font-medium leading-4">
      Live Stream URL
    </label>
    <input
      name="liveStreamUrl"
      placeholder="Enter Live Stream URL"
      type="text"
      className="bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10"
      value={videoInputs?.liveStreamUrl || ""}
      onChange={handleChange}
    />
    {/* {videoErrors?.liveStreamUrl && (
      <p className="text-red-500 relative bottom-[-6px] text-[10px] left-2">
        Live Stream URL is required
      </p>
    )} */}
  </div>

  {/* Contact Person */}
  <div className="md:col-span-2 col-span-1">
    <label className="text-[12px] text-greyish font-medium leading-4">
      Contact Person
    </label>
    <input
      name="contactperson"
      placeholder="Enter Contact Person"
      type="text"
      className="bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10"
      value={videoInputs?.contactperson || ""}
      onChange={handleChange}
    />
    {/* {videoErrors?.contactperson && (
      <p className="text-red-500 relative bottom-[-6px] text-[10px] left-2">
        Contact Person is required
      </p>
    )} */}
  </div>

  {/* Contact Phone */}
  <div className="md:col-span-1 col-span-1">
    <label className="text-[12px] text-greyish font-medium leading-4">
      Contact Phone
    </label>
    <input
      name="contactphone"
      placeholder="Enter Contact Phone"
      type="tel"
      className="bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10"
      value={videoInputs?.contactphone || ""}
      onChange={handleChange}
    />
    {/* {videoErrors?.contactphone && (
      <p className="text-red-500 relative bottom-[-6px] text-[10px] left-2">
        Contact Phone is required
      </p>
    )} */}
  </div>

  {/* Contact Email */}
  <div className="md:col-span-1 col-span-1">
    <label className="text-[12px] text-greyish font-medium leading-4">
      Contact Email
    </label>
    <input
      name="contactemail"
      placeholder="Enter Contact Email"
      type="email"
      className="bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10"
      value={videoInputs?.contactemail || ""}
      onChange={handleChange}
    />
    {/* {videoErrors?.contactemail && (
      <p className="text-red-500 relative bottom-[-6px] text-[10px] left-2">
        Contact Email is required
      </p>
    )} */}
  </div>
{/* Subscription URL */}
<div className="md:col-span-2 col-span-1">
  <label className="text-[12px] text-greyish font-medium leading-4">
    Subscription URL
  </label>
  <input
    name="subscriptionUrl"
    placeholder="Enter Subscription URL"
    type="text"
    className="bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10"
    value={videoInputs?.subscriptionUrl || ""}
    onChange={handleChange}
  />
</div>

{/* Register URL */}
<div className="md:col-span-2 col-span-1">
  <label className="text-[12px] text-greyish font-medium leading-4">
    Register URL
  </label>
  <input
    name="registerUrl"
    placeholder="Enter Register URL"
    type="text"
    className="bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10"
    value={videoInputs?.registerUrl || ""}
    onChange={handleChange}
  />
</div>

  <div className="md:col-span-2 col-span-1">

   <GalleryPickerField
  label=" Cover Image"
  name="galleryImage"
  church={church}
  rowData={rowData}
  value={{
    web: { url: tumbNailUrlsInputs?.webUploadUrl },
    tablet: { url: tumbNailUrlsInputs?.tabletUploadUrl },
    mobile: { url: tumbNailUrlsInputs?.mobileUploadUrl },
  }}
  handleChange={handleGallerySelect}
/>
{
  currentUrl.includes("addChannelField") ? (
    <VideoPickerfield
      label="Select Video"
      name="thumbnail"
      church={church}
      handleChange={handleThumbSelect}
    />
  ) : currentUrl.includes("addMinistryField") ? (
    <MinistryVideoField
      label="Select Video"
      name="thumbnail"
      church={church}
      rowData={rowData}
      handleChange={handleThumbSelect}
    />
  ) : (
    <GalleryVideoField
      label="Select Video"
      name="thumbnail"
      church={church}
      rowData={rowData}
      handleChange={handleThumbSelect}
    />
  )
}

     {/* <button
                  className="text-yellowish mt-4 bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
                  onClick={()=>handleSaveCarecellCoverImage(rowData)}
                >Save Cover Image</button> */}
                   <div className="flex items-center gap-4 mt-4">
        <input
          type="checkbox"
          id="liveCheckbox"
          className="w-4 h-4 cursor-pointer accent-yellowish appearance-none border border-gray-300 rounded-full checked:bg-yellow-500 checked:border-yellow-500"
          checked={isLive}
          onChange={(e) => setIslive(e.target.checked)}
        />
        <label htmlFor="liveCheckbox" className="cursor-pointer select-none">
          Live
        </label>

        <input
          type="checkbox"
          id="defaultCheckbox"
          className="w-4 h-4 cursor-pointer accent-yellowish appearance-none border border-gray-300 rounded-full checked:bg-yellow-500 checked:border-yellow-500"
          checked={isDefault}
          onChange={(e) => setIsDefault(e.target.checked)}
        />
        <label htmlFor="defaultCheckbox" className="cursor-pointer select-none">
          Default
        </label>
      </div>
</div>
{/* )} */}

</div>

                </div>
              </div>

            )}
            <Tooltip id="add_church" className="border border-greyish border-opacity-20" />
          </div>
        </div>
      </div>
      <CollapsibleRightPanel title="Stats / Layouts">
        <CustomTabsV2
          tabHeight={"h-[64px]"}
          tabsTitleArray={["Stats", "Layouts"]}
          tabsContentObject={{
            Stats: (
              <div className="mt-8 flex items-center justify-center w-full text-white">
                {data?._id ? (
                  <div className="w-full px-8">
                    <p>
                      Views : <strong>{videoInputs?.totalViews}</strong>
                    </p>
                    <p>
                      Likes: <strong>{videoInputs?.totalLikes}</strong>
                    </p>
                  </div>
                ) : (
                  <>No stats available for video</>
                )}
              </div>
            ),
            Layouts: !data?._id ? (
              <div className="mt-8 flex items-center justify-center w-full text-white">
                Save this Church to assign the layout
              </div>
            ) : (
              <>
                <div className="mt-4 p-1">
                  <label htmlFor="relatedVideos" className="text-[12px] text-greyish font-medium">
                    Layouts
                  </label>
                  <div className="bg-blackish py-4 px-3 mt-3 rounded-lg">
                    <LayoutDropdown
                      setMyState={setLayoutValues}
                      setLayoutInfo={setLayoutInfo}
                      setAddedLayout={setAddedLayout}
                      addedLayout={addedLayout}
                      newTarget={editTargetLayout}
                      isLayoutEdit={isLayoutEdit}
                      outerTargetLayout={layoutValues?.layout_name}
                    />

                    {layoutInfo && (
                      <>
                        <div className="flex gap-3">
                          <div className="w-full">
                            <label
                              htmlFor="order"
                              className="text-[12px] text-greyish font-medium leading-4 "
                            >
                              Display Order
                            </label>
                            <input
                              type="text"
                              className={`bg-greyishV2 p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10`}
                              name="order"
                              placeholder="Enter order"
                              value={layoutValues?.order}
                              onChange={handleVideoLayoutChange}
                            />
                          </div>
                        </div>
                        <div className="flex justify-end mt-4">
                          <div className="flex gap-3">
                            {!isLayoutEdit && (
                              <button
                                className="text-greyish bg-blackishV2 font-medium text-[12px] rounded-xl py-2 px-6"
                                onClick={() => {
                                  setLayoutValues(initialLayoutValues);
                                  setLayoutInfo(false);
                                }}
                              >
                                Cancel
                              </button>
                            )}
                            {isLayoutEdit ? (
                              <button
                                className="text-yellowish bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
                                onClick={handleLayoutUpdate}
                              >
                                Confirm
                              </button>
                            ) : (
                              <button
                                className="text-yellowish bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
                                onClick={handleAddLayoutToArray}
                              >
                                Add
                              </button>
                            )}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
                {layoutArray?.length > 0 &&
                  activeTab === "en" &&
                  layoutArray?.map((item, index) => (
                    <div className="w-full px-4 mt-4">
                      <div className="w-full p-2 px-4 bg-black bg-opacity-10 rounded-lg border border-opacity-25 border-white">
                        <div className="flex flex-col items-center justify-center w-full text-white">
                          <div className="flex justify-between w-full">
                            <p className="text-sm font-white font-medium text-white">
                              {item?.layout_name}
                            </p>
                            <div className="flex gap-2 justify-end items-center cursor-pointer">
                              <img
                                className="h-4"
                                src={edit}
                                alt=""
                                onClick={() => {
                                  setIsLayoutEdit(true);
                                  setEditLayoutIndex(index);
                                  setLayoutValues(item);
                                  setEditTargetLayout(item?.layout_name);
                                }}
                              />
                              <img
                                className="h-4"
                                src={close}
                                alt=""
                                onClick={() => {
                                  handleDeleteLayoutFromArray(item?._id);
                                }}
                              />
                            </div>
                          </div>
                          <div className="flex justify-between w-full mt-5 bg-blackishV2 p-1 px-2">
                            <p className="text-[10px] font-white text-white">Order</p>
                          </div>
                          <div className="flex w-full mt-2 p-1 px-2">
                            <p className="flex w-full text-xs font-white font-bold text-white">
                              {item?.order}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </>
            ),
          }}
        />
      </CollapsibleRightPanel>

    </div>
  );
};

export default AddVideosFields;
